import extensionIcon from '../functions/extension-icon'

export default ({ Vue }) => {
    Vue.prototype.$extensionIcon = extensionIcon
}
